export const isInEmbeddedMode = (): boolean => !!window.ReactNativeWebView;
